import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app-module';

// Fetch runtime config (written by Ansible from env-variables.yml at deploy time)
// before Angular bootstraps so MSAL gets the correct per-environment clientId.
fetch('/assets/config.json')
  .then(res => {
    if (!res.ok) throw new Error(`Failed to fetch config.json: ${res.status}`);
    return res.json();
  })
  .then(config => {
    (window as any).__appConfig = config;
    platformBrowser().bootstrapModule(AppModule)
      .catch(err => console.error(err));
  })
  .catch(err => {
    console.error('Could not load application configuration. Authentication may fail.', err);
    platformBrowser().bootstrapModule(AppModule)
      .catch(e => console.error(e));
  });
